<template>
  <section>
    <div class="container">
      <ul class="breadcrumb">
        <li v-for="crumb in breadcrumbs"
            :class="{active:crumb.active}">
          <span v-if="crumb.active"
                v-html="crumb.name">
          </span>
          <a v-else
             :href="crumb.seo_link"
             v-html="crumb.name">
          </a>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "breadcrumbs",
    computed:{
        ...mapState({
          breadcrumbs:e=>e.persistent.currentNav
        })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/breadcrumbs.vue